<div class="row">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
    <h2 class="mat-dialog-title">
      Patient Details

      <button
        (click)="closeDialog()"
        type="button"
        class="float-end btn btn-sm"
      >
        <mat-icon>close</mat-icon>
      </button>
    </h2>
  </div>
</div>
<form>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="form-section p-1">
        <div>
          <div class="user-panel-registration">
            <div class="image">
              <img
                *ngIf="!(patient.ProfilePictureId!=0 && patient.ProfilePictureId!=null)"
                class="user-img"
                alt="User Image"
                height="100"
                src="assets/images/user/patient-1.png"
              />
              <img
                *ngIf="patient.ProfilePictureId!=0 && patient.ProfilePictureId!=null"
                #profilePic
                class="user-img"
                [src]="imgSrc"
                alt="User Image"
                height="100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
      <div
        class="example-full-width view-patient-div p-b-20"
        appearance="outline"
      >
        <span class="font-weight"> Name:&nbsp; </span
        >{{patient.FirstName}}&nbsp;{{patient.MiddleName==null?'':patient.MiddleName}}&nbsp;{{patient.LastName}}
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Email&nbsp;:&nbsp; </span>{{(patient.Email
        ==null || patient.Email =='')?'- -':patient.Email}}
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Phone&nbsp;:&nbsp;</span>{{(patient.Phone
        ==null || patient.Phone =='')?'- -':patient.Phone}}
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Gender&nbsp;:&nbsp;</span> {{ patient.Gender
        != ''?(patient.Gender == 'M'?'Male':'Female'):'' }}
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Age&nbsp;:&nbsp;</span>{{(patient.Age ==null)?'- -':patient.Age}}
      </div>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Allergies&nbsp;:&nbsp;</span>{{(patient.Note
        == null || patient.Note == '')?'- -':patient.Note}}
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Guarantor&nbsp;:&nbsp;</span
        >{{(patient.Guarantor == null || patient.Guarantor == '')?'-
        -':patient.Guarantor}}
      </div>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Insurance information&nbsp;:&nbsp;</span
        >{{patient.InsuranceInformation == null?'-
        -':patient.InsuranceInformation}}
      </div>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Patient Identifier&nbsp;:&nbsp;</span
        >{{patient.PatientIdentifier == null || patient.PatientIdentifier ==
        ''?'- -':patient.PatientIdentifier}}
      </div>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-b-20">
      <div class="example-full-width view-patient-div" appearance="outline">
        <span class="font-weight"> Address&nbsp;:&nbsp;</span>{{(patient.Address
        == null || patient.Address == '')?'- -':patient.Address}}
      </div>
    </div>
  </div>
</form>
